<template>
  <div class="spell-selector">
    <div class="row">
      <div class="col-3 mb-4" v-for="(spell,idx) in parsedSpellbook" :key="idx">
        <div @mouseover="() => {hoverSpell = spell}" @mouseleave="() => {hoverSpell = null}" @click="selected(spell)">
          <Spell :spell="spell"></Spell>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-4 pr-2">
        <div class="row">
          <div class="col-12 mb-1">
            <div class="spellbook p-33" @click="$emit('spellbookSwap', 'standard')">
              <img loading="lazy" sizes="100%, 100%" src="/static/images/icons/spellbook_standard.png"
                   alt="Standard Spellbook"
                   title="Standard Spellbook">
            </div>
          </div>
          <div class="col-12">
            <div class="spellbook p-33" @click="$emit('spellbookSwap', 'ancients')">
              <img loading="lazy" sizes="100%, 100%" src="/static/images/icons/spellbook_ancient.png"
                   alt="Ancient Spellbook" title="Ancient Spellbook">
            </div>
          </div>
        </div>
      </div>
      <div class="col-8 pl-0">
        <div class="info-container">
          <div class="info-box p-3" v-if="hoverSpell !== null">
            <div class="row">
              <div class="col-12">
                <span>{{hoverSpell.name}}</span>
              </div>
              <div class="col-12">
                <div class="hitsplat">
                  <span class="result-value" v-b-tooltip.hover.bottom
                        title="Base Max Hit">{{hoverSpell.base_max_hit}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spell from "./Spell";

  export default {
    name: "SpellSelector",
    components: {Spell},
    props: {
      spellbook: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        hoverSpell: null,
      }
    },
    computed: {
      parsedSpellbook: function () {
        //TODO Handle each staffs casting options (crumble undead etc)

        return Object.keys(this.spellbook.spells).filter((key) => {
          if (this.isIbanBlast(key)) {
            return false
          }
          if (this.isMagicDart(key)) {
            return false
          }

          if (this.isCrumbleUndead(key)) {
            return false
          }

          if (this.isGodSpell(key)) {
            return false
          }

          return true;


        }).map((key) => {
          return this.spellbook.spells[key];
        });

      },
    },
    methods: {
      selected: function (spell) {
        this.$emit('selected', spell)
      },

      isGodSpell: function (spellId) {
        return ["260", "265", "270"].includes(spellId)
      },

      isCrumbleUndead: function (spellId) {
        return spellId === "130"
      },

      isIbanBlast: function (spellId) {
        return spellId === "170"
      },

      isMagicDart: function (spellId) {
        return spellId === "175"
      }
    }
  }
</script>

<style scoped>
  .info-container {
    position: relative;
    width: 100%;
    height: 100%;
    background: black;
    color: white
  }

  .spellbook > img {
    transform: scale(1.4);
  }

  .p-33 {
    padding: 0.6rem !important;
  }

  .hitsplat {
    min-height: 45px;
    min-width: 45px;
  }

  .result-value {
    font-size: 1.3rem;
    font-weight: bold;
    line-height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/SpellSelector.vue